"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STOCK_OUT_PRICE_SCALE = exports.HKD_FX_RATES = void 0;
exports.notionalToCashFlow = notionalToCashFlow;
exports.convertCashFlowsToHkdCents = convertCashFlowsToHkdCents;
/** 原币 → HKD 固定汇率，活动期内不随行情变。 */
exports.HKD_FX_RATES = {
    HKD: 1,
    USD: 7.82,
    CNY: 1.14,
    CNH: 1.14,
    AUD: 5.72,
    SGD: 5.85,
    JPY: 0.052,
    NZD: 4.7596,
    CAD: 5.9248,
    MYR: 1.71,
    THB: 0.2399,
};
/** 转出 close_price 为原币价格 × 10^9。 */
exports.STOCK_OUT_PRICE_SCALE = 1000000000;
/**
 * 股票 / 期权数量 × 报价 → 原币金额。
 * priceScale 默认 1；转出 close_price 传 STOCK_OUT_PRICE_SCALE。
 */
function notionalToCashFlow(params) {
    const count = Number(params.count) || 0;
    const raw = Number(params.price);
    const scale = params.priceScale && params.priceScale > 0 ? params.priceScale : 1;
    if (count === 0 || !Number.isFinite(raw)) {
        return null;
    }
    const amount = count * (raw / scale);
    if (!Number.isFinite(amount) || amount === 0) {
        return null;
    }
    return {
        currency: params.currency || '',
        amount,
    };
}
/**
 * 将多币种金额按固定汇率折港分后加总。
 * 表外币种不计入，列入 unknownCurrencies。
 */
function convertCashFlowsToHkdCents(items) {
    let netHkdCents = 0;
    const unknownCurrencies = [];
    const seenUnknown = new Set();
    for (const item of items) {
        const currency = (item.currency || '').trim().toUpperCase();
        const rate = exports.HKD_FX_RATES[currency];
        if (rate === undefined) {
            if (currency && !seenUnknown.has(currency)) {
                seenUnknown.add(currency);
                unknownCurrencies.push(currency);
            }
            continue;
        }
        netHkdCents += Math.round(item.amount * rate * 100);
    }
    return { netHkdCents, unknownCurrencies };
}
